import React from "react";
import Table from "../../../../components/Table";
import TitleButtons from "../../../../components/TitleButtons";
import { useSaidasSuprimentos } from "./Saidas-servicoData";

const DiretoriaServicosSaidas: React.FC = () => {
  const headers = [
    "OS",
    "Tipo", // 👈 NOVO
    "Código",
    "Nome do Produto",
    "Quantidade",
    "Custo Unitário",
    "Técnico",
    "Data",
    "Hora",
  ];

  const { rows, loading, refresh } = useSaidasSuprimentos();

  const columnWidths = [
    "60px", // OS
    "80px", // Tipo 👈 NOVO
    "70px", // Código
    "300px", // Nome
    "50px", // Quantidade
    "70px", // Custo
    "90px", // Técnico
    "90px", // Data
    "60px", // Hora
  ];

  return (
    <div>
      <TitleButtons
        title="Diretoria - Saídas serviços"
        buttons={
          [
            //  {
            //    label: "Gerar Relatório",
            //    onClick: () => console.log("Relatório gerado"),
            //    variant: "secondary",
            //  },
          ]
        }
      />
      <Table headers={headers} rows={rows} columnWidths={columnWidths} />
    </div>
  );
};

export default DiretoriaServicosSaidas;
